import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { WebServiceService } from '../../shared/services/web-service.service';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { EesDesService } from '../../shared/services/ees-des.service';
import { Cookie } from 'ng2-cookies';
import { ToasterService } from 'angular2-toaster';
@Component({
  selector: 'app-dynamic-company-level-pie-chart',
  templateUrl: './dynamic-company-level-pie-chart.component.html',
  styleUrls: ['./dynamic-company-level-pie-chart.component.scss']
})
export class DynamicCompanyLevelPieChartComponent implements OnInit {

  @Input() labels: string[];
  @Input() data: number[];
  @Input() pieChartType?: string = 'pie';
  @Input() colors?: any = ['#5fb2c6', '#53a759', '#e88b44', '#e23f3d']
  @Input() lineChartLegend?: boolean = true;
  @Input() title: any;
  @Input() Actualkey: any;
  @Input() rowData: any;
  @Input() tempItems: any;
  @Input() backgroundColor:any
  @Input() company_title:any;
  @Input() tempLabel:any = []
  pieChartColors: any;
  public pieChartPlugins = [pluginDataLabels];


  public options: any = {
    legend: {
      position: 'right',
      orient: 'vertical',
      display:false
    },
    plugins: {
      datalabels: {
       display:false
      }
    }
  }

  constructor(private router: Router, public webService: WebServiceService, public _localStorageService: LocalStorageService, public eesdesService: EesDesService, private toasterService: ToasterService) { }

  ngOnInit() {
    this.pieChartColors = [{ backgroundColor: this.backgroundColor }];
    this.id = this._localStorageService.getUserId();
    this.getCompanies();
    this.showLogoutIssue(false);
    this.GetCompanySetUpData();
  }

  public chartClicked(e: any, data): void {
    // console.log(data)
    // console.log(this.key)
    // console.log(e)
    if (e.active.length > 0) {
      const chart = e.active[0]._chart;
      const activePoints = chart.getElementAtEvent(e.event);
      if (activePoints.length > 0) {
        // get the internal index of slice in pie chart
        const clickedElementIndex = activePoints[0]._index;
        const label = chart.data.labels[clickedElementIndex];
        // get value by index
        // console.log(chart.data)
        // console.log(chart.data.datasets[0])
        const value = chart.data.datasets[0].data[clickedElementIndex];
        // console.log(value)
        // console.log(label)
        this.navigateUrl(this.Actualkey, value, label);
      }
    }
  }

  chartHovered(e: any): void {
    console.log(e)
  }
  currentCompanyId: any = this.eesdesService.get('company_id', localStorage.getItem('company_id')) ? this.eesdesService.get('company_id', localStorage.getItem('company_id')) : "";
  pieChartCompanyId: any = this.eesdesService.get('company_id', localStorage.getItem('company_id')) ? this.eesdesService.get('company_id', localStorage.getItem('company_id')) : "";
  navData:any={is_other_project:false,link:'',data:{}}
  navigateUrl(key, value, label) {
    // console.log(key)
    // console.log(value)
    // console.log(label)
    let tempLabel = label ? label.replace(/\s+/g, '').toLowerCase() : "";
    let TempArray = this.tempItems ? this.tempItems.filter((d) => { return d.count_title == tempLabel }) : [];
    this.pieChartCompanyId = TempArray ? TempArray[0].company_id : this.eesdesService.get('company_id', localStorage.getItem('company_id'));
    let url = "";
    let project = '';

    let dashboardAction = ""
    if (TempArray) {
      switch (key) {
        case "pending_pr":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/allpr-approvals";
          project = 'operation'
          dashboardAction = "";
          break;
        case "pending_po":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/po-approval";
          project = 'operation'
          dashboardAction = ""
          break;

        case "pending_ir":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/allir-approvals";
          project = 'operation'
          dashboardAction = ""
          break;

        case "pending_iv":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/invoice-approval";
          project = 'operation'
          dashboardAction = ""
          break;
        case "pending_ip":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/invoice-payment-approval";
          project = 'operation'
          dashboardAction = ""
          break;
        case "pending_adhoc_advance_payment":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/adhoc-advance-payment-approval";
          project = 'operation'
          dashboardAction = ""
          break;
        case "po_hold":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/hold-po-for-additional-info";
          project = 'operation'
          dashboardAction = ""
          break;
        case "pending_grn":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/add-grn";
          project = 'operation'
          dashboardAction = "approved_po"
          break;
        case "pending_sales_order":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/sales-order-approval";
          project = 'o2c'
          dashboardAction = ""
          break;
        case "pending_sales_invoice":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/sales-invoice-for-approval";
          project = 'o2c'
          dashboardAction = ""
          break;
        case "pending_boq":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/boq-approval";
          project = 'master'
          dashboardAction = ""
          break;
        case "journal_entry":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/je-approval";
          project = 'finance'
          dashboardAction = ""
          break;
          case "cvppm_pending_approval":
            // if (+this.pieChartCompanyId != this.currentCompanyId) {
            //   this.setCompany(this.pieChartCompanyId)
            // }
            url = "/cvppm_approval";
            project = 'mapping'
            dashboardAction = ""
            break;
        case "pending_project":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/project-master-approval";
          project = 'project_management'
          dashboardAction = "rejected_items"
          break;
        case "pending_task":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/task-master-approval";
          project = 'project_management'
          dashboardAction = ""
          break;
        case "pending_timesheet":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/time-sheet-approval";
          project = 'project_management'
          dashboardAction = ""
          break;
        case "pending_expense":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/expense-sheet-v2-approval";
          project = 'project_management'
          dashboardAction = ""
          break;
        case "pending_stock_issue":
          // if (+this.pieChartCompanyId != this.currentCompanyId) {
          //   this.setCompany(this.pieChartCompanyId)
          // }
          url = "/stock-issue-approval";
          project = 'asset_management'
          dashboardAction = ""
          break;
          case "customer_balance_approval":
            url = "/customer-balance-approval";
            project = 'report'
            dashboardAction = ""
            break;
        default:
          url = "";
      }
    }
    if(key!='pending_stock_issue')
    {
    localStorage.setItem("dashboardAction", this.webService.set(dashboardAction, 'dashboardAction'));
    }
    if (url != '' && url != undefined) {
      let redirectUrl = '/#';
      let origin = window.location.origin;
      if (project == 'master') {
        redirectUrl = origin + '/master' + redirectUrl + url;
      } else if (project == 'reports') {
        redirectUrl = origin + '/report' + redirectUrl + url;
      } else if (project == 'mapping') {
        redirectUrl = origin + '/mapping' + redirectUrl + url;
      } else if (project == 'finance') {
        redirectUrl = origin + '/finance' + redirectUrl + url;
      }
      else if (project == 'project_management') {
        redirectUrl = origin + '/project_management/' + redirectUrl + url;
      }
      else if (project == 'o2c') {
        redirectUrl = origin + '/o2c/' + redirectUrl + url;
      }
      else if (project == 'asset_management') {
        redirectUrl = origin + '/asset_management/' + redirectUrl + url;
      }

      else {
        if (url == '#' || !url) return;
        // this.webService.redirectURL(url);
        this.navData.link=url
        this.navData.is_other_project=false
        if (+this.pieChartCompanyId != this.currentCompanyId) {
          this.setCompany(this.pieChartCompanyId)
        }
        else
        {
          this.webService.redirectURL(url);
        }
        return;
      }
      this.navData.link=redirectUrl
      this.navData.is_other_project=true
      if (+this.pieChartCompanyId != this.currentCompanyId) {
        this.setCompany(this.pieChartCompanyId)
      }
      else
      {
      window.location.href = redirectUrl;
      }
    }
  }

  companyData: any = { is_multiple: false, list: [], data: {}, searchComp: '', company_id: this._localStorageService.getEmpCompanyId() }
  getCompanies() {
    let requestObj = {
      "emp_id": this._localStorageService.getUserId(),
      "company_id": '0',
    }
    this.companyData.list = [];
    this.webService.commonPostMethod('employees/ajax_getsingemp_companies_details', requestObj).
      subscribe(
        data => {
          if (data.status == true) {
            this.companyData.data = data.empdata ? data.empdata : { companies: [] };
            if (this.companyData.data.companies) {
              for (let i of this.companyData.data.companies) {
                i.name = i.company_title + "(" + i.company_code + ")"
                i.id = i.company_id.toString()
              }
              this.companyData.company_id = this.companyData.company_id.toString();
            }
            this.companyData.list = this.companyData.data.companies ? this.companyData.data.companies : []

          }
        }, error => {
        }
      );
  }
  setCompany(companyId: any) {
    try {
      let x: any = {}
      x = this.companyData.list.filter((v) => { return v.id == companyId })[0]
      localStorage.removeItem('menus');
      localStorage.removeItem('is_menu')
      localStorage.removeItem('costcenters')
      this.setLocalStorage(x)
    }
    catch (err) {
      console.warn(err)
    }
  }
  setLocalStorage(data) {
    sessionStorage.setItem('company_id', data.company_id);
    if (this.eesdesService.get('ven_role', localStorage.getItem('ven_role')) == 'vendor') {
      this.setVendorDetails(data);
      localStorage.setItem("company_id", this.eesdesService.set(data.company_id));
      localStorage.setItem("emp_role", this.eesdesService.set("vendor"));
      localStorage.setItem("company_code", this.eesdesService.set(data.company_code));

      localStorage.setItem("company_title", this.eesdesService.set(data.company_title));
      localStorage.setItem("company_logo", this.eesdesService.set(data.company_logo));
      localStorage.setItem("company_theme", this.eesdesService.set(data.company_theme));
      localStorage.setItem("company_theme_text", this.eesdesService.set(data.company_theme_text));

      // localStorage.setItem("company_setup",JSON.stringify(data.company_setup));
      data.company_setup.MINUTES_UNITL_AUTO_LOGOUT = data.company_setup.MINUTES_UNITL_AUTO_LOGOUT ? data.company_setup.MINUTES_UNITL_AUTO_LOGOUT : 10
      localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT', data.company_setup.MINUTES_UNITL_AUTO_LOGOUT)
      data.company_setup.enable_strict_auto_logout_policy = data.company_setup.enable_strict_auto_logout_policy ? data.company_setup.enable_strict_auto_logout_policy : '0';
      localStorage.setItem('enable_strict_auto_logout_policy', data.company_setup.enable_strict_auto_logout_policy);
    }
    else {
      this.setEmployeeDetails(data);
      localStorage.setItem("company_id", this.eesdesService.set(data.company_id));
      localStorage.setItem("emp_role", this.eesdesService.set(data.employee_role));
      localStorage.setItem("company_title", this.eesdesService.set(data.company_title));
      localStorage.setItem("company_code", this.eesdesService.set(data.company_code));

      localStorage.setItem("company_logo", this.eesdesService.set(data.company_logo));
      data.company_setup.MINUTES_UNITL_AUTO_LOGOUT = data.company_setup.MINUTES_UNITL_AUTO_LOGOUT ? data.company_setup.MINUTES_UNITL_AUTO_LOGOUT : 10
      localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT', data.company_setup.MINUTES_UNITL_AUTO_LOGOUT)
      data.company_setup.enable_strict_auto_logout_policy = data.company_setup.enable_strict_auto_logout_policy ? data.company_setup.enable_strict_auto_logout_policy : '0';
      localStorage.setItem('enable_strict_auto_logout_policy', data.company_setup.enable_strict_auto_logout_policy);
      localStorage.setItem("company_theme", this.eesdesService.set(data.company_theme));
      localStorage.setItem("company_theme_text", this.eesdesService.set(data.company_theme_text));
    }
    this.getAccessToken();
  }
  setVendorDetails(data) {
    localStorage.setItem("emp_role", this.eesdesService.set("vendor"));
    sessionStorage.setItem('company_id', data.company_id);
    localStorage.setItem("company_id", this.eesdesService.set(data.company_id));
    localStorage.setItem("emp_role", this.eesdesService.set("vendor"));
    if (this.companyData.list) {
      if (this.companyData.list) {
        for (let j of this.companyData.list) {
          if (j.company_id == data.company_id) {
            localStorage.setItem("employee_code", this.eesdesService.set(j.vendor_code));
            localStorage.setItem("company_title", this.eesdesService.set(j.company_title));
            localStorage.setItem("company_code", this.eesdesService.set(j.company_code));
            localStorage.setItem("company_logo", this.eesdesService.set(j.company_logo));
            localStorage.setItem("emp_role", this.eesdesService.set("vendor"));
            let user = {
              "email": j.email,
              "emp_details_id": j.vendor_id,
              "employeecode": j.vendor_code ? j.vendor_code : '',
              "first_name": j.first_name,
              "gender": j.gender,
              "hiredate": j.hiredate,
              "id": j.id,
              "image": j.image,
              "last_name": j.last_name,
              "leavedate": j.leavedate,
              "middle_name": j.middle_name,
              "mobile": j.mobile,
              "password": j.password,
              "pincode": j.pincode,
              "status": j.status,
            }

          }
        }
      }
    }
    window.location.reload();

  }

  setEmployeeDetails(data) {
    if (this.companyData.data) {

      if (this.companyData.data.companies) {
        for (let j of this.companyData.data.companies) {
          if (j.company_id == data.company_id) {
            this.companyData.data.employee_role = j.employee_role;
            this.companyData.data.employee_code = j.employee_code;
            this.companyData.data.company_id = j.company_id;
            this.companyData.data.company_title = j.company_title;
            this.companyData.data.company_code = j.company_code ? j.company_code : '';
            this.companyData.data.company_logo = j.company_logo;
            localStorage.setItem("employee_code", this.eesdesService.set(j.employee_code));
            j.company_setup = j.company_setup ? j.company_setup : {};
            j.company_setup.MINUTES_UNITL_AUTO_LOGOUT = j.company_setup.MINUTES_UNITL_AUTO_LOGOUT ? j.company_setup.MINUTES_UNITL_AUTO_LOGOUT : 10
            localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT', j.company_setup.MINUTES_UNITL_AUTO_LOGOUT)
            j.company_setup.enable_strict_auto_logout_policy = j.company_setup.enable_strict_auto_logout_policy ? j.company_setup.enable_strict_auto_logout_policy : '0';
            localStorage.setItem('enable_strict_auto_logout_policy', j.company_setup.enable_strict_auto_logout_policy);
            let user = {
              "email": this.companyData.data.email,
              "emp_details_id": this.companyData.data.emp_details_id,
              "employeecode": this.companyData.data.employeecode,
              "first_name": this.companyData.data.first_name,
              "gender": this.companyData.data.gender,
              "hiredate": this.companyData.data.hiredate,
              "id": this.companyData.data.id,
              "image": this.companyData.data.image,
              "last_name": this.companyData.data.last_name,
              "leavedate": this.companyData.data.leavedate,
              "middle_name": this.companyData.data.middle_name,
              "mobile": this.companyData.data.mobile,
              "password": this.companyData.data.password,
              "pincode": this.companyData.data.pincode,
              "status": this.companyData.data.status,
            }

          }
        }
      }
    }
    localStorage.setItem("ven_role", this.eesdesService.set(""));

  }

  getAccessToken() {
    let requestObj = {
      "company_id": this.eesdesService.get('company_id', localStorage.getItem('company_id')) ? this.eesdesService.get('company_id', localStorage.getItem('company_id')) : '0',
    }
    this.webService.commonPostMethod('Companies/company_get_token', requestObj).
      subscribe(
        data => {
          if (data.status) {
            Cookie.set("access_token", data.response);
            document.cookie = "access_token=" + data.response + ";secure";
            localStorage.setItem('access_token', this.eesdesService.set(data.response));
            this.setHttpCookie({
              "action": "set",
              "cookie_name": "access_token",
              "cookie_value": this.eesdesService.set(data.response, 'access_token'),
              "expire": "72000"
            })
            this.New_getUserAccessToken();
            this.getUserDetailsForDepartment();
          }
          else {
            this.toasterService.pop("error", "Error", data.message);
            window.localStorage.clear();
            window.location.reload();
          }

        }, error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }
  id: any = 0;
  getUserDetailsForDepartment() {
    console.log('company funtion called !')
    let requestObj = {
      "company_id": this.eesdesService.get('company_id', localStorage.getItem('company_id')) ? this.eesdesService.get('company_id', localStorage.getItem('company_id')) : '0',
      "emp_id": this.id ? this.id : '',
    }

    this.webService.commonPostMethod('employees/ajax_getsingemp', requestObj).
      subscribe(
        data => {
          if (data.status == true) {
            let empDetails: any;
            empDetails = data;
            console.log(empDetails)
            if (empDetails.empdata != undefined && empDetails.empdata != '') {

              if (empDetails.empdata) {
                if (empDetails.empdata.cost_centers.length > 0) {
                  let costcenters = empDetails.empdata.cost_centers.filter((v) => { return v.company_id == this._localStorageService.getEmpCompanyId() });
                  if (costcenters) {
                    for (let i of costcenters) {
                      i.is_administrative_location = i.is_administrative_location ? i.is_administrative_location : '0';
                      i.is_sez=i.is_sez?i.is_sez:'0';
                      // if(this.hasUnicode(i.location_name_9_digit))
                      // {
                      //   try{
                      //   // i.location_name_9_digit=i.location_name_9_digit.replace(/[\u0080-\u07ff]/g, "-")
                      //   }catch(e){}
                      //   // console.log(i);
                      // }

                      // i.sez=i.is_sez?i.is_sez:'0'
                    }
                  }
                  localStorage.setItem('costcenters', this.eesdesService.set(JSON.stringify(costcenters)))
                  // send to last logout screen
                }
                if (empDetails.empdata.companies) {
                  for (let j of empDetails.empdata.companies) {
                    if (j.employee_id == this.id) {
                      j.company_setup = j.company_setup ? j.company_setup : {};
                      // localStorage.setItem("company_setup", JSON.stringify(j.company_setup));
                      j.company_setup.MINUTES_UNITL_AUTO_LOGOUT = j.company_setup.MINUTES_UNITL_AUTO_LOGOUT ? j.company_setup.MINUTES_UNITL_AUTO_LOGOUT : 10
                      localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT', j.company_setup.MINUTES_UNITL_AUTO_LOGOUT)
            j.company_setup.enable_strict_auto_logout_policy = j.company_setup.enable_strict_auto_logout_policy ? j.company_setup.enable_strict_auto_logout_policy : '0';
            localStorage.setItem('enable_strict_auto_logout_policy', j.company_setup.enable_strict_auto_logout_policy);
                      localStorage.setItem("department_id", this.eesdesService.set(j.department ? j.department : ''));
                      localStorage.setItem("department_name", this.eesdesService.set(j.department_name ? j.department_name : ''));
                      localStorage.setItem("profile_image", this.eesdesService.set(j.profile_image ? j.profile_image : ''));


                    }
                  }
                }
              }

            }
            else {
            }

          }


        }, error => {

        }
      );
  }
  setHttpCookie(payload) {
    this.webService.commonPostMethod('login/cookies', payload).
      subscribe(
        data => {
          if (data.status) {
          }
          else {
          }
        }, error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }
  already_active: boolean = false;
  already_active_msg: any = ''
  New_getUserAccessToken() {
    let requestObj = {
      "company_id": this.eesdesService.get('company_id', localStorage.getItem('company_id')) ? this.eesdesService.get('company_id', localStorage.getItem('company_id')) : '0',
    }
    this.webService.commonPostMethod('User_session_management/generate_token', requestObj).
      subscribe(
        data => {
          if (data.status) {
            localStorage.setItem('user_access_token', this.eesdesService.set(data.response));
            this.getMenuList()
            this.showLogoutIssue(false);
            // window.location.reload();
          }
          else if (data.already_active) {
            this.already_active = true;
            this.already_active_msg = data.message;
            // window.location.reload();
              this.getMenuList()
          }
          else {
            if (this.eesdesService.get('company_id', localStorage.getItem('company_id')) == null || this.eesdesService.get('company_id', localStorage.getItem('company_id')) == "0") {
              // window.location.reload();
              this.getMenuList()
            }
            else {
              this.toasterService.pop("error", "Error", data.message);
              window.localStorage.clear();
              window.location.href = window.location.href
            }
          }
        }, error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }
  showLogoutIssue(flag: boolean) {
    if (flag) {
      document.getElementById("IssueSidenavUserSession").style.width = "35%";
      document.getElementById("showIssueModelUserSession").style.display = "block";
      document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    } else {
      document.getElementById("IssueSidenavUserSession").style.width = "0";
      document.getElementById("showIssueModelUserSession").style.display = "none";
      document.body.style.backgroundColor = "#f0f0f1";
    }
  }
  downloadCanvas(event, name) {
    let anchor = event.target;
    // get the canvas
    anchor.href = document.getElementsByTagName('canvas')[0].toDataURL();
    name = name ? name : 'report';
    anchor.download = name + ".png";
  }
  menuList:any=[]
  getMenuList() {
    let id=''
    if (this._localStorageService.getUserRole() == "administrator") {
      id = "0"
    }
    else {
      id = this._localStorageService.getEmpRoleId() == undefined || this._localStorageService.getEmpRoleId() == null ? "0" : this._localStorageService.getEmpRoleId();

    }
    let data = {
      "id": id,
      "company_id": this._localStorageService.getEmpCompanyId() == undefined || this._localStorageService.getEmpCompanyId() == null ? "0" : this._localStorageService.getEmpCompanyId(),
    }
    this.webService.commonPostMethod("User_Roles/ajax_menu_items_by_user_role", data).
      subscribe(
        data => {
          if (data.status) {
            let temp: any = [];
              temp = data.response?data.response:[]
            if (temp) {
              for (let i of temp) {
                if (i.submenu) {
                  for (let j of i.submenu) {
                    if (j.aurl == "/bug-master") {
                      j.menuitemname = "Bug Master";
                    }
                    if (j.aurl == "/my-bug-master") {
                      j.menuitemname = "My " + "Bug Master"
                    }
                  }
                }
              }
            }
            this.menuList = temp;
            let comArray = this.companyData.list.filter((v) => { return v.company_id == this._localStorageService.getEmpCompanyId() })
            localStorage.setItem('companies', this.eesdesService.set(JSON.stringify(comArray?comArray:[])))
            localStorage.setItem("menus", this.eesdesService.set(JSON.stringify(this.menuList)));
            localStorage.setItem("is_menu", this.eesdesService.set('1'));
            let currentUrl: string = window.location.hash.substring(1);
            for (let x of this.menuList) {
              if (x.submenu) {
                for (let d of x.submenu) {
                  if (currentUrl == d.aurl && d.aurl!='/dashboard') {

                    d.activemenu = true;
                    x.show = true;
                    x.activemenu = true;
                    break;
                  } else {
                    d.activemenu = false
                    x.show = false;
                    x.activemenu = false;
                  }
                }
              }
            }
            if(this.menuList.length<=0){
              this.toasterService.pop('warning','Warning','You are not allowed to access this page');
              this.router.navigate(["/login"]);
            }
            if(this.navData.is_other_project==false && this.navData.link!='')
            {
              this.webService.redirectURL(this.navData.link)
            }
            if(this.navData.is_other_project==true && this.navData.link!='')
            {
              window.location.href=this.navData.link;
            }
          }
        },
        error => {

        }
      );
  }
    company_setup: any = {};
    GetCompanySetUpData() {
    let req = {
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? "0" : this._localStorageService.getEmpCompanyId(),
      variable_list:["hide_pie_charts_in_dashboard"],
    }
    this.company_setup={}
    this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany_limited_as_requested", req).subscribe(
      data => {
        if (data.status) {
          this.company_setup={}
          this.company_setup=data.response ? data.response : {}
          this.company_setup.hide_pie_charts_in_dashboard=this.company_setup.hide_pie_charts_in_dashboard?this.company_setup.hide_pie_charts_in_dashboard:'0';
        }
        else {
          this.toasterService.pop('error', "Error", data.message);
        }


      }
    )
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4103618664/src/src/app/common/dynamic-company-level-pie-chart/dynamic-company-level-pie-chart.component.ts